<div class="main-div content-w-98">
  <div class="title-div">
    <div class="headerName">
      <span>Project reporting</span>
    </div>
    <div class="subTitleName">
      <span>Generate your report </span>
    </div>
  </div>

  <ng-container *ngIf="showIncorrectEOLNotification">
    <piqet-angular-incorrect-data-notification
      [message]="incorrectValueMessage"
      [buttonName]="incorrectBtnName"
      [componentName]="'end-of-life'"
      (eolAction)="eolAction($event)"
    ></piqet-angular-incorrect-data-notification>
  </ng-container>

  <ng-container *ngIf="showIncorrectFillingNotification">
    <piqet-angular-incorrect-data-notification
      [message]="incorrectFillingValueMessage"
      [componentName]="'fill-data-list'"
      [buttonName]="incorrectFillingBtnName"
      (eolAction)="eolAction($event)"
    ></piqet-angular-incorrect-data-notification>
  </ng-container>

  <div class="dropdowns-div">
    <form [formGroup]="reportChartForm">
      <div class="row" *ngIf="ui.showReportTitle">
        <div class="col-12">
          <p class="note-div gray-font">Edit report name</p>
        </div>
        <div class="col-12 input-div">
          <div class="form-group required" aria-required="true">
            <piqet-angular-common-input
              formControlName="reportTitle"
              [control]="reportChartForm.get('reportTitle')"
              label="Report title"
              placeholder="Report title"
              inputType="text"
              [preventDot]="true"
              [submitted]="finalSubmit"
            >
            </piqet-angular-common-input>
          </div>
        </div>
      </div>

      <div class="d-flex justify-content-end" *ngIf="showEdit">
        <a class="add-link" target="_blank" routerLink="/my-organization/project-report-setting"
          ><span class="redirectLinkText">Add project report custom setting</span></a
        >
        <a
          class="setLinkIconPosition"
          target="_blank"
          replaceUrl="true"
          routerLink="/my-organization/project-report-setting"
        >
          <img src="./assets/icons/redirect-icon.svg" alt="" width="15" height="13" />
        </a>
        <span class="setLinkIconPosition" (click)="loadFormData()"
          ><img src="./assets/icons/refresh-circle.svg" alt="" width="14" height="13"
        /></span>
      </div>

      <div class="row scenarios-div ng-select-div reportGenerationDrd">
        <div class="col-12 col-md-6">
          <label
            *ngIf="reportChartForm.controls['newFormateList']?.value"
            class="sub-header-drpdown pb-2"
            >Report format *</label
          >
          <ng-select
            [clearable]="false"
            [clearOnBackspace]="false"
            #reportFormate
            joyrideStep="adv-14"
            stepPosition="top"
            text="Select from a PDF, PPT or excel report format."
            (prev)="onPrev('adv-14')"
            (change)="onChangeReportFormat($event)"
            formControlName="newFormateList"
            [items]="reportFormats"
            [searchable]="false"
            bindLabel="name"
            [searchFn]="commonInputSearchName"
            [multiple]="false"
            placeholder="Report format *"
          >
            <ng-template ng-header-tmp>
              <div class="has-feedback">
                <input
                  placeholder="Search..."
                  (input)="reportFormate.filter($any($event.target).value)"
                  type="text"
                  class="form-control search-input"
                  id="inputValidation"
                />
                <span class="form-control-feedback">
                  <i class="fa fa-search icon"></i>
                </span>
              </div>
            </ng-template>
            <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
              <div
                [ngOptionHighlight]="search"
                title="{{ item?.name }}"
                [class.disabled]="item?.disabled"
                class="option-content"
              >
                <span class="option-text-wrapper">
                  <span>{{ item.name }}</span>
                  <span class="coming-soon-label" *ngIf="item?.comingSoonLabel">{{
                    item.comingSoonLabel
                  }}</span>
                  <app-crown-icon
                    *ngIf="item?.disabled && item?.isFeatureDisabled"
                    [tooltip]="'This feature is not available in your current plan'"
                    [size]="16"
                    [color]="'#9747FF'"
                    [customClass]="'ml-2'"
                  >
                  </app-crown-icon>
                </span>
              </div>
            </ng-template>
          </ng-select>
          <div
            *ngIf="
              (finalSubmit || reportChartForm.controls['newFormateList']?.touched) &&
              reportChartForm.controls['newFormateList']?.invalid
            "
            class="input-error"
          >
            Report format is required.
          </div>
        </div>

        <div class="col-12 col-md-6 reportGenerationDrd">
          <label
            *ngIf="
              reportChartForm.controls['reportFormatByList']?.value ||
              reportChartForm.controls['newFormateList']?.value
            "
            class="sub-header-drpdown pb-2"
            >Report type *</label
          >
          <ng-select
            [clearable]="false"
            [clearOnBackspace]="false"
            #reportListByFormat
            joyrideStep="adv-15"
            stepPosition="top"
            text="Select a predefined report or create your own custom report."
            (change)="onChangeReportType($event)"
            formControlName="reportFormatByList"
            [items]="reportTypeCategories"
            [searchable]="false"
            bindLabel="name"
            [searchFn]="commonInputSearchName"
            [multiple]="false"
            placeholder="Report type *"
            groupBy="types"
            [readonly]="!ui.showReportType"
          >
            <ng-template ng-header-tmp>
              <div class="has-feedback">
                <input
                  placeholder="Search..."
                  (input)="reportListByFormat.filter($any($event.target).value)"
                  type="text"
                  class="form-control search-input"
                  id="inputValidation"
                />
                <span class="form-control-feedback">
                  <i class="fa fa-search icon"></i>
                </span>
              </div>
            </ng-template>

            <ng-template ng-optgroup-tmp let-item="item" let-search="searchTerm">
              <div
                title="{{ item?.name }}"
                [class.disabled]="item?.disabled"
                class="option-group-content"
              >
                <span class="option-text-wrapper">
                  <span [ngOptionHighlight]="search">{{ item?.name }}</span>
                  <app-crown-icon
                    *ngIf="item?.disabled && item?.isFeatureDisabled"
                    [tooltip]="'This feature is not available in your current plan'"
                    [size]="16"
                    [color]="'#9747FF'"
                    [customClass]="'ml-2'"
                  >
                  </app-crown-icon>
                </span>
              </div>
            </ng-template>

            <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
              <div
                title="{{ item?.name }}"
                [class.disabled]="item?.disabled"
                class="option-content"
              >
                <span class="option-text-wrapper">
                  <span [ngOptionHighlight]="search">{{ item.name }}</span>
                  <app-crown-icon
                    *ngIf="item?.disabled && item?.isFeatureDisabled"
                    [tooltip]="'This feature is not available in your current plan'"
                    [size]="16"
                    [color]="'#9747FF'"
                    [customClass]="'ml-2'"
                  >
                  </app-crown-icon>
                </span>
              </div>
            </ng-template>
          </ng-select>
          <div *ngIf="!ui.showReportType && !isExportProjectSummary" class="input-error">
            *Unavailable for report format
          </div>
          <div
            *ngIf="
              (finalSubmit || reportChartForm.controls['reportFormatByList']?.touched) &&
              reportChartForm.controls['reportFormatByList']?.invalid
            "
            class="input-error"
          >
            Report type is required.
          </div>
        </div>
      </div>

      <div class="row" *ngIf="ui.showFunctionalUnit || ui.showBaseScenario">
        <div class="col-12 col-md-6 ng-select-div reportGenerationDrd" *ngIf="ui.showFunctionalUnit">
          <label
            *ngIf="
              reportChartForm.controls['functionalUnit']?.value ||
              reportChartForm.controls['baselineScenario']?.value
            "
            class="sub-header-drpdown pb-2"
            >Functional unit *</label
          >
          <ng-select
            formControlName="functionalUnit"
            [clearable]="false"
            [clearOnBackspace]="false"
            [items]="functionalUnits"
            #functionalUnit
            [searchable]="false"
            bindLabel="name"
            [searchFn]="commonInputSearchName"
            placeholder="Functional unit *"
          >
            <ng-template ng-header-tmp>
              <div class="has-feedback">
                <input
                  placeholder="Search..."
                  type="text"
                  class="form-control search-input"
                  id="inputValidation"
                  (input)="functionalUnit.filter($any($event.target).value)"
                />
                <span class="form-control-feedback">
                  <i class="fa fa-search icon"></i>
                </span>
              </div>
            </ng-template>
            <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
              <div [ngOptionHighlight]="search" title="{{ item?.name }}">{{ item.name }}</div>
            </ng-template>
          </ng-select>
          <div
            *ngIf="
              (finalSubmit || reportChartForm.controls['functionalUnit']?.touched) &&
              reportChartForm.controls['functionalUnit']?.invalid
            "
            class="input-error"
          >
            Function unit is required
          </div>
        </div>

        <div class="col-12 col-md-6 ng-select-div reportGenerationDrd" *ngIf="ui.showBaseScenario">
          <label
            *ngIf="
              reportChartForm.controls['baselineScenario']?.value ||
              reportChartForm.controls['functionalUnit']?.value
            "
            class="sub-header-drpdown pb-2"
            >Base scenario *</label
          >
          <ng-select
            #baselineScenario
            [clearable]="false"
            [clearOnBackspace]="false"
            formControlName="baselineScenario"
            [items]="scenarios"
            [searchable]="false"
            bindLabel="description"
            [searchFn]="commonInputSearchDes"
            (change)="changeBaseScenario($event)"
            placeholder="Base scenario *"
          >
            <ng-template ng-header-tmp>
              <div class="has-feedback">
                <input
                  placeholder="Search..."
                  type="text"
                  class="form-control search-input"
                  id="inputValidation"
                  (input)="baselineScenario.filter($any($event.target).value)"
                />
                <span class="form-control-feedback">
                  <i class="fa fa-search icon"></i>
                </span>
              </div>
            </ng-template>
            <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
              <div [ngOptionHighlight]="search" title="{{ item?.description }}">
                {{ item.description }}
              </div>
            </ng-template>
          </ng-select>
          <div
            *ngIf="
              (finalSubmit || reportChartForm.controls['baselineScenario']?.touched) &&
              reportChartForm.controls['baselineScenario']?.invalid
            "
            class="input-error"
          >
            Please select base scenario
          </div>
        </div>
      </div>

      <div class="row" *ngIf="ui.showFunctionalUnitText">
        <div class="form-group">
          <div class="side-by-side-container">
            <div class="row">
              <div class="form-group">
                <label class="sub-header-drpdown pb-2">Functional unit text</label>
                <div class="services-form">
                  <textarea
                    formControlName="functionalUnitText"
                    class="resizable-textarea"
                    cols="20"
                    id="Description"
                    name="Description"
                    rows="6"
                    (input)="onFunctionalUnitChange()"
                    placeholder="Functional unit text"
                    (change)="onSaveFunctionalUnitText()"
                  ></textarea>
                  <div *ngIf="finalSubmit" class="input-error">
                    <ng-container *ngTemplateOutlet="functionalUnitTextError"></ng-container>
                  </div>
                </div>
              </div>
            </div>

            <piqet-angular-text-preview
              [text]="functionalUnitText"
              [labelText]="'Functional unit text preview in reports'"
              [textPrefix]="'Accordingly, the FU for this study is '"
              [textSuffix]="''"
              [highlightText]="true"
              [maxLength]="50"
              [truncatePosition]="'end'"
              [truncateIndicator]="'...'"
            ></piqet-angular-text-preview>
          </div>
        </div>
      </div>

      <div class="scenarios-to-include-div">
        <div class="row">
          <div class="col-12">
            <p *ngIf="ui.scenarioHint" class="note-div gray-font">{{ ui.scenarioHint }}</p>
          </div>
          <div class="col-12 ng-select-div reportGenerationDrd">
            <label
              *ngIf="reportChartForm.controls['includeScenario']?.value"
              class="sub-header-drpdown pb-2"
              >Scenarios to include *</label
            >
            <ng-select
              #scenario
              formControlName="includeScenario"
              [clearable]="false"
              [items]="scenarios"
              [searchable]="false"
              bindLabel="description"
              bindValue="idStr"
              [searchFn]="commonInputSearchDes"
              (click)="onScenarioPickerClick($event)"
              [maxSelectedItems]="maxScenarios"
              [multiple]="true"
              [isOpen]="$any(scenarioPickerIsOpen)"
              placeholder="Scenarios to Include *"
              [readonly]="ui.showBaseScenario && isEnableAllScenarioDrp"
            >
              <ng-template ng-header-tmp>
                <div class="has-feedback">
                  <input
                    placeholder="Search..."
                    type="text"
                    class="form-control search-input"
                    id="inputValidation"
                    (input)="scenario.filter($any($event.target).value)"
                  />
                  <span class="form-control-feedback">
                    <i class="fa fa-search icon"></i>
                  </span>
                </div>
              </ng-template>
              <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
                <div [ngOptionHighlight]="search" title="{{ item?.description }}">
                  {{ item?.description }}
                </div>
                <span *ngIf="item?.idStr == selectedBaseScenario" class="badge scenario-badge"
                  >Base scenario</span
                >
              </ng-template>
            </ng-select>
            <div
              *ngIf="finalSubmit && reportChartForm.controls['includeScenario']?.invalid"
              class="input-error"
            >
              Please select scenarios
            </div>
            <div class="input-error" *ngIf="isShowScenarioNotification">
              <span>Select a base scenario to proceed.</span>
            </div>
          </div>
        </div>
      </div>

      <div>
        <div class="row">
          <div class="col-12 check-box-div" *ngIf="ui.showIncludeInputInformation">
            <div class="d-flex checkBoxAlienMent">
              <div>
                <input
                  formControlName="includeInputInformation"
                  type="checkbox"
                  class="chkOverview"
                />
              </div>
              <div>
                <span style="color: black; margin-left: 10px">Include input information</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row" *ngIf="showImpactCategory">
        <div class="col-12 ng-select-div reportGenerationDrd">
          <label
            *ngIf="reportChartForm.controls['impactCategories']?.value"
            class="sub-header-drpdown pb-2"
            >Impact categories *</label
          >
          <ng-select
            #impactCategorySelect
            [clearable]="false"
            [clearOnBackspace]="false"
            (change)="onChangeImpactCategory($event)"
            formControlName="impactCategories"
            [items]="impactCategories"
            [searchable]="false"
            bindLabel="name"
            [searchFn]="commonInputSearchName"
            placeholder="Impact categories *"
          >
            <ng-template ng-header-tmp>
              <div class="has-feedback">
                <input
                  placeholder="Search..."
                  type="text"
                  class="form-control search-input"
                  id="inputValidation"
                  (input)="impactCategorySelect.filter($any($event.target).value)"
                />
                <span class="form-control-feedback">
                  <i class="fa fa-search icon"></i>
                </span>
              </div>
            </ng-template>
            <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
              <div
                title="{{ item?.name }}"
                [class.disabled]="item?.disabled"
                class="option-content"
              >
                <span class="option-text-wrapper">
                  <span [ngOptionHighlight]="search"> {{ item.name }}</span>
                  <app-crown-icon
                    *ngIf="item?.disabled && item?.isFeatureDisabled"
                    [tooltip]="'This feature is not available in your current plan'"
                    [size]="16"
                    [color]="'#9747FF'"
                    [customClass]="'ml-2'"
                  >
                  </app-crown-icon>
                </span>
              </div>
            </ng-template>
          </ng-select>
          <div
            *ngIf="finalSubmit && reportChartForm.controls['impactCategories']?.invalid"
            class="input-error"
          >
            Impact categories are required.
          </div>
        </div>
      </div>

      <div class="scenarios-to-include-div" *ngIf="showCategoriesToInclude">
        <div class="row">
          <div class="col-12" *ngIf="ui.categoryHint">
            <p class="note-div gray-font">{{ ui.categoryHint }}</p>
          </div>
          <div class="col-12 ng-select-div reportGenerationDrd">
            <label
              *ngIf="reportChartForm.controls['includeCategories']?.value"
              class="sub-header-drpdown pb-2"
              >Categories to include *</label
            >
            <ng-select
              formControlName="includeCategories"
              [clearable]="false"
              [items]="indicators"
              [searchable]="false"
              bindLabel="name"
              bindValue="id"
              [ngClass]="
                reportChartForm.controls['includeCategories'].value?.length > 11
                  ? 'multi-select'
                  : ''
              "
              [searchFn]="commonInputSearchName"
              [multiple]="true"
              [maxSelectedItems]="maxCategories"
              [isOpen]="false"
              placeholder="Categories to include *"
              (click)="onCategoryPickerClick($event)"
            >
            </ng-select>
            <div
              *ngIf="
                (finalSubmit || reportChartForm.controls['includeCategories']?.touched) &&
                reportChartForm.controls['includeCategories']?.invalid
              "
              class="input-error"
            >
              Categories to include are required.
            </div>
          </div>
        </div>
      </div>

      <div class="row" *ngIf="isShowVersion">
        <div class="col-12 ng-select-div reportGenerationDrd">
          <label
            *ngIf="reportChartForm.controls['version']?.value"
            class="sub-header-drpdown pb-2"
            >Select version *</label
          >
          <ng-select
            #version
            formControlName="version"
            [clearable]="false"
            [clearOnBackspace]="false"
            [items]="versions"
            [searchable]="false"
            bindLabel="name"
            bindValue="id"
            [searchFn]="commonInputSearchName"
            placeholder="Select version *"
          >
            <ng-template ng-header-tmp>
              <div class="has-feedback">
                <input
                  placeholder="Search..."
                  type="text"
                  class="form-control search-input"
                  id="inputValidation"
                  (input)="version.filter($any($event.target).value)"
                />
                <span class="form-control-feedback">
                  <i class="fa fa-search icon"></i>
                </span>
              </div>
            </ng-template>
            <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
              <div [ngOptionHighlight]="search" title="{{ item?.name }}">{{ item.name }}</div>
            </ng-template>
          </ng-select>
          <div
            *ngIf="
              (finalSubmit || reportChartForm.controls['version']?.touched) &&
              reportChartForm.controls['version']?.invalid
            "
            class="input-error"
          >
            Version is required.
          </div>
        </div>
      </div>

      <ng-container *ngIf="joyrideService.isTourInProgress() || isShowSensitivityAnalysis">
        <p
          *ngIf="!joyrideService.isTourInProgress() && scenarios.length < 2"
          class="text-danger my-3"
        >
          To enable Sensitivity analysis, add more than 1 scenario in your project
        </p>
        <div [ngClass]="scenarios.length < 2 ? 'disabled-project' : ''">
          <div [formGroup]="sensitivityReportForm">
            <div *ngFor="let item of formArray; let i = index" formArrayName="items">
              <div
                formGroupName="{{ i }}"
                class="sensitivity-analysis-item"
                [class.remove-hover-border]="hoveredIndex === i"
              >
                <span
                  class="sensiHeading header-text-crown-icon"
                  joyrideStep="adv-16"
                  stepPosition="right"
                  (prev)="onPrev('adv-16')"
                  (next)="onNext('adv-16')"
                  text="You may conduct multiple sensitivity analyses to present how variations in input data could affect the study results."
                  >Sensitivity analysis {{ i + 1 }}
                  <button
                    *ngIf="i != 0"
                    type="button"
                    class="btn-hover-remove"
                    (click)="removeSensitivityItem(i)"
                    (mouseenter)="setHoveredIndex(i)"
                    (mouseleave)="setHoveredIndex(null)"
                    ngbTooltip="Click to remove this sensitivity analysis from the list"
                    placement="left"
                    tooltipClass="sku-tooltip"
                  >
                    Remove
                  </button>
                </span>
                <p class="text-danger my-2" *ngIf="isCheckVariation && errorIndex == i">
                  Variation is required
                </p>
                <div class="row scenarios-div ng-select-div reportGenerationDrd">
                  <div class="col-12">
                    <label
                      class="sub-header-drpdown pb-2"
                      *ngIf="sensitivityValue(i, 'addRefrences')"
                      >Add reference for sensitivity analysis</label
                    >
                    <ng-select
                      [clearable]="true"
                      [clearOnBackspace]="false"
                      #addRedefrences
                      joyrideStep="adv-17"
                      stepPosition="right"
                      (next)="onNext('adv-17')"
                      (prev)="onPrev('adv-17')"
                      [items]="scenarios"
                      [searchable]="false"
                      bindLabel="description"
                      text="Label a reference scenario to be used as a baseline for the analysis."
                      [formControlName]="'addRefrences'"
                      bindValue="idStr"
                      [searchFn]="commonInputSearchDes"
                      [multiple]="false"
                      placeholder="Add reference for sensitivity analysis"
                      (change)="selectAddRefrences($event, i)"
                      (clear)="resetCalculations(i)"
                    >
                      <ng-template ng-header-tmp>
                        <div class="has-feedback">
                          <input
                            placeholder="Search..."
                            (input)="addRedefrences.filter($any($event.target).value)"
                            type="text"
                            class="form-control search-input"
                            id="inputValidation"
                          />
                          <span class="form-control-feedback">
                            <i class="fa fa-search icon"></i>
                          </span>
                        </div>
                      </ng-template>
                      <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
                        <div [ngOptionHighlight]="search" title="{{ item?.description }}">
                          {{ item.description }}
                        </div>
                      </ng-template>
                    </ng-select>
                  </div>
                </div>
                <div class="row scenarios-div ng-select-div reportGenerationDrd">
                  <div class="col-12 col-md-6">
                    <label
                      class="sub-header-drpdown pb-2"
                      *ngIf="sensitivityValue(i, 'variationOne')"
                      >Variation 1</label
                    >
                    <label
                      *ngIf="
                        !sensitivityValue(i, 'variationOne') && sensitivityValue(i, 'variationTwo')
                      "
                      style="visibility: hidden"
                      class="sub-header-drpdown pb-2"
                      >Holder_Text</label
                    >
                    <ng-select
                      [clearable]="true"
                      [clearOnBackspace]="false"
                      #Variation1
                      joyrideStep="adv-18"
                      stepPosition="right"
                      text="Label up to four variations, which are scenarios used throughout the project."
                      (prev)="onPrev('adv-18')"
                      [formControlName]="'variationOne'"
                      [items]="variationLists"
                      [searchable]="false"
                      bindLabel="description"
                      [searchFn]="commonInputSearchDes"
                      bindValue="idStr"
                      [multiple]="false"
                      placeholder="Variation 1"
                      (open)="changeVariation($event, i, 1)"
                      (change)="checkVariationValue($event, i, 1)"
                    >
                      <ng-template ng-header-tmp>
                        <div class="has-feedback">
                          <input
                            placeholder="Search..."
                            (input)="Variation1.filter($any($event.target).value)"
                            type="text"
                            class="form-control search-input"
                            id="inputValidation"
                          />
                          <span class="form-control-feedback">
                            <i class="fa fa-search icon"></i>
                          </span>
                        </div>
                      </ng-template>
                      <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
                        <div [ngOptionHighlight]="search" title="{{ item?.description }}">
                          {{ item.description }}
                        </div>
                      </ng-template>
                    </ng-select>
                  </div>
                  <div class="col-12 col-md-6 reportGenerationDrd">
                    <label
                      class="sub-header-drpdown pb-2"
                      *ngIf="sensitivityValue(i, 'variationTwo')"
                      >Variation 2</label
                    >
                    <label
                      *ngIf="
                        sensitivityValue(i, 'variationOne') && !sensitivityValue(i, 'variationTwo')
                      "
                      style="visibility: hidden"
                      class="sub-header-drpdown pb-2"
                      >Holder_Text</label
                    >
                    <ng-select
                      [clearable]="true"
                      [clearOnBackspace]="false"
                      #Variation2
                      [formControlName]="'variationTwo'"
                      [items]="variationLists"
                      [searchable]="false"
                      bindLabel="description"
                      [searchFn]="commonInputSearchDes"
                      bindValue="idStr"
                      [multiple]="false"
                      placeholder="Variation 2"
                      (open)="changeVariation($event, i, 2)"
                      (change)="checkVariationValue($event, i, 2)"
                    >
                      <ng-template ng-header-tmp>
                        <div class="has-feedback">
                          <input
                            placeholder="Search..."
                            (input)="Variation2.filter($any($event.target).value)"
                            type="text"
                            class="form-control search-input"
                            id="inputValidation"
                          />
                          <span class="form-control-feedback">
                            <i class="fa fa-search icon"></i>
                          </span>
                        </div>
                      </ng-template>
                      <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
                        <div [ngOptionHighlight]="search" title="{{ item?.description }}">
                          {{ item.description }}
                        </div>
                      </ng-template>
                    </ng-select>
                  </div>
                </div>
                <div class="row scenarios-div ng-select-div reportGenerationDrd">
                  <div class="col-12 col-md-6">
                    <label
                      class="sub-header-drpdown pb-2"
                      *ngIf="sensitivityValue(i, 'variationThree')"
                      >Variation 3</label
                    >
                    <label
                      *ngIf="
                        !sensitivityValue(i, 'variationThree') &&
                        sensitivityValue(i, 'variationFour')
                      "
                      style="visibility: hidden"
                      class="sub-header-drpdown pb-2"
                      >Holder_Text</label
                    >
                    <ng-select
                      [clearable]="true"
                      [clearOnBackspace]="false"
                      #Variation3
                      [formControlName]="'variationThree'"
                      [items]="variationLists"
                      [searchable]="false"
                      bindLabel="description"
                      [searchFn]="commonInputSearchDes"
                      bindValue="idStr"
                      [multiple]="false"
                      placeholder="Variation 3"
                      (open)="changeVariation($event, i, 3)"
                      (change)="checkVariationValue($event, i, 3)"
                    >
                      <ng-template ng-header-tmp>
                        <div class="has-feedback">
                          <input
                            placeholder="Search..."
                            (input)="Variation3.filter($any($event.target).value)"
                            type="text"
                            class="form-control search-input"
                            id="inputValidation"
                          />
                          <span class="form-control-feedback">
                            <i class="fa fa-search icon"></i>
                          </span>
                        </div>
                      </ng-template>
                      <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
                        <div [ngOptionHighlight]="search" title="{{ item?.description }}">
                          {{ item.description }}
                        </div>
                      </ng-template>
                    </ng-select>
                  </div>
                  <div class="col-12 col-md-6 reportGenerationDrd">
                    <label
                      class="sub-header-drpdown pb-2"
                      *ngIf="sensitivityValue(i, 'variationFour')"
                      >Variation 4</label
                    >
                    <label
                      *ngIf="
                        sensitivityValue(i, 'variationThree') &&
                        !sensitivityValue(i, 'variationFour')
                      "
                      style="visibility: hidden"
                      class="sub-header-drpdown pb-2"
                      >Holder_Text</label
                    >
                    <ng-select
                      [clearable]="true"
                      [clearOnBackspace]="false"
                      #Variation4
                      [formControlName]="'variationFour'"
                      [items]="variationLists"
                      [searchable]="false"
                      bindLabel="description"
                      [searchFn]="commonInputSearchDes"
                      bindValue="idStr"
                      [multiple]="false"
                      placeholder="Variation 4"
                      (open)="changeVariation($event, i, 4)"
                      (change)="checkVariationValue($event, i, 4)"
                    >
                      <ng-template ng-header-tmp>
                        <div class="has-feedback">
                          <input
                            placeholder="Search..."
                            (input)="Variation4.filter($any($event.target).value)"
                            type="text"
                            class="form-control search-input"
                            id="inputValidation"
                          />
                          <span class="form-control-feedback">
                            <i class="fa fa-search icon"></i>
                          </span>
                        </div>
                      </ng-template>
                      <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
                        <div [ngOptionHighlight]="search" title="{{ item?.description }}">
                          {{ item.description }}
                        </div>
                      </ng-template>
                    </ng-select>
                  </div>
                </div>
              </div>
            </div>
            <div
              class="add-btn-snt"
              [ngbTooltip]="tooltipMessage"
              placement="auto"
              tooltipClass="sku-tooltip"
              *ngIf="tooltipMessage; else noTooltip"
            >
              <button
                [disabled]="checkDisabledRef()"
                class="blue-hoki-add"
                type="button"
                (click)="addItem()"
                (mouseenter)="changeImageOnHover(true)"
                [innerHTML]="headerBtn"
                (mouseleave)="changeImageOnHover(false)"
              ></button>
            </div>

            <ng-template #noTooltip>
              <button
                [disabled]="checkDisabledRef()"
                class="blue-hoki-add"
                type="button"
                (click)="addItem()"
                (mouseenter)="changeImageOnHover(true)"
                [innerHTML]="headerBtn"
                (mouseleave)="changeImageOnHover(false)"
              ></button>
            </ng-template>

            <hr class="hr" />
          </div>
        </div>
      </ng-container>

      <div class="setButtonAndError text-margin">
        <div class="modal-footer">
          <button
            *ngIf="selectedFormat?.id == NewReportFormatEnum.LCAReport && !isExportProjectSummary"
            [disabled]="
              reportChartForm.controls['newFormateList'].invalid ||
              reportChartForm.controls['reportFormatByList'].invalid
            "
            (click)="onGenerateReport('save')"
            class="modelBtn"
          >
            Save
          </button>
          <button
            *ngIf="!isExportProjectSummary"
            [innerHTML]="buttonName"
            joyrideStep="adv-19"
            stepPosition="right"
            text="Generate the report and view your results!
            Remember you can always go back to edit or add anything you've missed."
            type="submit"
            class="ISOsaveBtn"
            (click)="onGenerateReport()"
            [disabled]="
              reportChartForm.controls['newFormateList'].invalid ||
              reportChartForm.controls['reportFormatByList'].invalid ||
              reportChartForm.controls['includeCategories'].invalid ||
              !isReportGeneratable
            "
          ></button>
          <button
            type="button"
            *ngIf="isShareVisible"
            (click)="openShareModal()"
            class="next-btn modelBtn"
            [disabled]="
              reportChartForm.controls['newFormateList'].invalid ||
              reportChartForm.controls['reportFormatByList'].invalid ||
              !isReportGeneratable
            "
          >
            Share
          </button>
          <button
            *ngIf="isExportProjectSummary"
            name="Export Project Summary"
            type="button"
            (click)="onExportProjectSummary()"
            [disabled]="isExporting"
            class="modelBtn"
          >
            Export
          </button>
        </div>

        <div
          class="redErrorTag"
          *ngIf="
            finalSubmit &&
            (reportChartForm.controls['includeScenario']?.invalid ||
              reportChartForm.controls['functionalUnit']?.invalid ||
              reportChartForm.controls['baselineScenario']?.invalid ||
              reportChartForm.controls['impactCategories']?.invalid ||
              reportChartForm.controls['includeCategories']?.invalid ||
              (isShowVersion && reportChartForm.controls['version']?.invalid) ||
              (isCheckISOReport && reportChartForm.controls['functionalUnitText']?.invalid) ||
              isCheckVariation)
          "
        >
          <div class="bigScreenErrContain">
            <div>
              <span> <img src="./assets/icons/swalDeletion.svg" width="53" height="48" /></span>
            </div>
            <div>
              <div class="mb-3">
                <span style="color: #f00">To proceed please complete the following fields : </span>
              </div>
              <div class="topBottomCss">
                <div *ngIf="reportChartForm.controls['includeScenario']?.invalid">
                  Please select scenarios
                </div>
              </div>
              <div class="topBottomCss">
                <div *ngIf="reportChartForm.controls['functionalUnit']?.invalid">
                  Function unit is required
                </div>
              </div>
              <div class="topBottomCss">
                <div *ngIf="reportChartForm.controls['baselineScenario']?.invalid">
                  Please select base scenario
                </div>
              </div>
              <div class="topBottomCss">
                <div *ngIf="reportChartForm.controls['impactCategories']?.invalid">
                  Impact categories are required
                </div>
              </div>
              <div class="topBottomCss">
                <div *ngIf="reportChartForm.controls['includeCategories']?.invalid">
                  Categories to include are required
                </div>
              </div>
              <div class="topBottomCss">
                <div *ngIf="isShowVersion && reportChartForm.controls['version']?.invalid">
                  Version is required
                </div>
              </div>
              <div class="topBottomCss">
                <ng-container *ngTemplateOutlet="functionalUnitTextError"></ng-container>
              </div>
              <div class="topBottomCss" *ngIf="isCheckVariation">Variation is required</div>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</div>
<ng-template #functionalUnitTextError>
  <div *ngIf="isCheckISOReport && reportChartForm.controls['functionalUnitText']?.invalid">
    Please enter functional unit text
  </div>
</ng-template>
